/*
 * Copyright (c) 2026 SimplyBook.me Ltd. All rights reserved.
 * Licensed under the Apache License, Version 2.0.
 */

import { queryOptions, useQuery, useSuspenseQuery } from "@tanstack/react-query";
import { fetcher } from "./fetcher";
import { queryKeys } from "./queryKeys";

export const pluginsQueryOptions = (queryParams) =>
  queryOptions({
    queryKey: queryKeys.plugins.all,
    queryFn: async () => {
      const response = await fetcher({ method: "GET", url: "/public/plugins" });
      return response.data;
    },
    staleTime: Infinity,
    ...queryParams,
  });

export const usePlugins = (queryParams) => useQuery(pluginsQueryOptions(queryParams));
export const useSuspensePlugins = (queryParams) => useSuspenseQuery(pluginsQueryOptions(queryParams));
